import { createStore } from 'zustand/vanilla';
import { debounce } from '@optimus-web/core';

export interface ComponentStoreEntry {
    html: HTMLElement;
    jsx: JSX.Element;
    elementId: string;
    isLazyRendered: boolean;
    showErrorAtBoundary: boolean;
}
interface ComponentStore {
    components: ComponentStoreEntry[];
    flushQueue: (componentsToAdd: ComponentStoreEntry[], elementIdsToRemove: string[]) => void;
}

export const backendComponentsStore = createStore<ComponentStore>((set) => ({
    components: [],

    flushQueue: (componentsToAdd, elementIdsToRemove) => {
        const toRemove = new Set(elementIdsToRemove);
        return set((state) => ({
            components: [...state.components, ...componentsToAdd].filter(
                (component) => !toRemove.has(component.elementId)
            ),
        }));
    },
}));

const BULK_STORE_UPDATE_DELAY = 10;
const syncQueue = {
    toAdd: [] as ComponentStoreEntry[],
    toRemove: [] as string[],
};

const flush = debounce(() => {
    backendComponentsStore.getState().flushQueue(syncQueue.toAdd, syncQueue.toRemove);
    syncQueue.toAdd = [];
    syncQueue.toRemove = [];
}, BULK_STORE_UPDATE_DELAY);

export const addBackendComponent = (component: ComponentStoreEntry) => {
    syncQueue.toAdd.push(component);
    flush();
};

export const removeBackendComponent = (elementId: string) => {
    syncQueue.toRemove.push(elementId);
    flush();
};
